import { Card } from "@/src/components";
import { useFrbBalances } from "@/src/hooks/useBalances";
import { useFarms } from "@/src/hooks/useFarms";
import { Timer } from "@/src/components/deadlineTimer";
import { useStake } from "@/src/hooks/useStake";
import { Button } from "@/src/components";
import { toast } from "react-hot-toast";
import { useAccount } from "wagmi";


export const CnyxBalance = () => {
  const { frbMinted, frbNftMinted, deadline } = useFrbBalances();
  const { onUseFaucet } = useStake();
  const { address, isConnected } = useAccount();

  const handleFaucet = async () => {
    if (!isConnected) return;

    toast.promise(onUseFaucet(), {
      loading: "Transaction is in progress",
      success: "Transaction successfully completed",
      error: (data) => data,
    });
  };
  return (
    <Card className="md:h-5/6 py-5">
      <div className="grid gap-3">
        <span className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            
            <h2 className="text-2xl text-foreground font-semibold">Balances</h2>
          </span>

          <div>
            
          </div>
        </span>

        <div>
          <p className="text-2xl md:text-3xl font-semibold text-foreground">
          {parseFloat(frbMinted).toFixed(2)}
          </p>
          <h2 className="text-xl font-semibold text-foreground/50">FRB from CRB & LP Burn</h2>
        </div>
        <div>
          <p className="text-2xl md:text-3xl font-semibold text-foreground">
          {parseFloat(frbNftMinted).toFixed(2)}
          </p>
          <h2 className="text-xl font-semibold text-foreground/50">
            FRB from NFTs
          </h2>
        </div>
        <div>
          <p className="text-2xl md:text-3xl font-semibold text-foreground">
          {parseInt(deadline) > 0 ? <Timer time={parseInt(deadline)}/> : "00:00:00:00"}
          </p>
          <h2 className="text-xl font-semibold text-foreground/50">Deadline</h2>
        </div>
      </div>
    </Card>
    
  );
};
